<app-main-header></app-main-header>
<div class="content">
    <!-- ======================= MOBILE VIEW ======================= -->
    <div class="mobile"> 
        <!-- Vehicle Overview and Create Vehicle Buttons Section (Hidden on Desktop) -->
        <div class="button-container">
            <button
                pButton
                type="button"
                label="Vehicles overview"
                icon="pi pi-truck"
                [routerLink]="['/vehicles']"
                class="grow-button"
            ></button>
            
            <!-- TODO: Add user roles so that not all users can create from their phone -->
            <!-- <button
                pButton
                type="button"
                label="Create Restriction"
                icon="pi pi-plus"
                (click)="showDialog = true"
                class="grow-button"
            ></button> -->
        </div>
    </div>

    <!-- ======================= DESKTOP VIEW ======================= -->
    <div class="desktop">
        @if (isAdmin$ | async) {
            <div style="display: flex; justify-content: flex-end; margin: 0.5rem 2.5rem 0 0;">
                <button pButton type="button" label="Create Restriction" icon="pi pi-plus" (click)="showDialog = true" class="add-restriction-button"></button>
            </div>
        }
    </div>

    <app-restriction-dialog [(visible)]="showDialog" (onSave)="handleSave($event)"></app-restriction-dialog>

    <app-restrictions-table></app-restrictions-table>
</div>